/* eslint-disable max-len */
<template>
  <sui-modal v-model="modalOpen">
    <sui-modal-header>Sociometric categories</sui-modal-header>
    <sui-modal-content class="scrolling">
      <classifications-legend-content
        v-bind:category="classificationLegendCategory"
      />
    </sui-modal-content>
    <sui-modal-actions>
      <sui-button positive v-on:click="hideClassificationLegend">
        Ok
      </sui-button>
    </sui-modal-actions>
  </sui-modal>
</template>

<script>
import { mapGetters } from 'vuex';
import ClassificationsLegendContent from './ClassificationsLegendContent';

export default {
  name: 'ClassificationsLegend',
  components: { ClassificationsLegendContent },
  computed: {
    ...mapGetters({
      classificationLegendOpen: 'classificationLegendOpen',
      classificationLegendCategory: 'classificationLegendCategory',
    }),
    modalOpen: {
      get() {
        return this.classificationLegendOpen;
      },
      set(isOpen) {
        this.hideClassificationLegend();
        return isOpen;
      },
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    hideClassificationLegend() {
      this.$store.dispatch('hideClassificationLegend');
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/tests/ClassificationsLegend.vue